"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Dot = require("./Dot");
Object.keys(_Dot).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Dot[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Dot[key];
    }
  });
});
var _WithDot = require("./WithDot");
Object.keys(_WithDot).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _WithDot[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _WithDot[key];
    }
  });
});